import React from "react";
import { Link } from "react-router-dom";
import stoneLogo from "./logos/stoneLogo.png";

export default function Footer() {

    return (
        <div id="bottom-block">
            <div className="row">
                <div className="column">
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/about">Learn More</Link></li>
                        <li><Link to="/contact">Reach Out</Link></li>
                        <li><Link to="/pricing">Pricing</Link></li>
                        <li><Link to="/playground">Playground</Link></li>
                    </ul>
                </div>
                <div className="column">
                    <ul>
                        <li><Link to="/privacy">Privacy Policy</Link></li>
                        <li><Link to="/terms">Terms and Conditions</Link></li>
                        <li><Link to="/disclaimers">Disclaimers</Link></li>
                    </ul>
                </div>
                <div className="nexus-col nexus-logo">
                    <ul>
                        <li><p style={{fontFamily: "Geist Mono, Courier New"}}>Powered by</p></li>
                        <li><a href="https://nexusstone.cloud" rel="noreferrer" target="_blank"><img src={ stoneLogo } alt=" Nexus Stone Solutions"></img></a></li>
                    </ul>
                </div>
            </div>
            <footer>
                <p>&copy; Copyright 2025-2026 <a href="https://nexusstone.cloud" rel="noreferrer" target="_blank"><i>Nexus Stone Solutions.</i></a></p>
                <p>Made for Academia. 📚</p>
            </footer>
        </div>
    )
}
